module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FJ-d96b7e032fa9e01e6603a8b528bebd54.png";